import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { CompletedContext } from './StepperComponent';
import _ from 'lodash';
import { validate } from '../../../utils/validateInputs';
import { Grid, FormHelperText, Button } from '@material-ui/core';
import BuildingInput from '../../Components/AddressInputs/BuildingInput';
import CorpsInput from '../../Components/AddressInputs/BuildingInput';
import FlatInput from '../../Components/AddressInputs/BuildingInput';
import * as styles from './stepperStyle';
import {
  requestDataDirectories
  // requestDataforSelectStatement
} from '../../../redux/actions/getSelectData';
import {
  saveAddress,
  apllicantData
} from '../../../redux/actions/applicantAction';
import isEmpty from '../../../validation/is-empty';

const useCompleted = () => {
  const contextValue = React.useContext(CompletedContext);
  return contextValue;
};

const Address = props => {
  const { applicant, directories } = props;
  const [completed, dispatch] = useCompleted();

  const [submitted, setSubmitted] = React.useState(false);
  const handleChange = React.useCallback(
    _.debounce(q => props.handleApplicantChange(q), 500),
    []
  );

  const handleInputChange = e => {
    const { target } = e;
    handleChange(target);
  };

  const handleSelectChange = React.useCallback(
    name => select => {
      props.handleSelectApplicantChange(name, select);
    },
    []
  );

  const handleSaveAddress = () => {
    const data = {
      id: props.application.id,
      subdivision: applicant.adressfact.i_subdivision,
      locality: applicant.adressfact.i_locality,
      street: applicant.adressfact.i_street,
      postindex: applicant.adressfact.i_postindex,
      housing: applicant.adressfact.c_housing,
      building: applicant.adressfact.c_building,
      flat: applicant.adressfact.c_flat
    };

    const newCompleted = completed;
    props
      .saveAddress(data)
      .then(resp => {
        newCompleted[props.activeStep] = true;
        // props.setCompleted(newCompleted);
        // props.handleNext();
        dispatch({ type: 'COMPLETED', payload: newCompleted });
        props.apllicantData(props.application.id);
        props.handleNext();
      })
      .catch(err => {
        newCompleted[props.activeStep] = false;
        // props.setCompleted(newCompleted);
        dispatch({ type: 'COMPLETED', payload: newCompleted });
      });
  };

  React.useEffect(() => {
    if (!isEmpty(applicant.adressfact.i_subdivision)) {
      props.requestDataDirectories(
        'i_subdivision_fact',
        applicant.adressfact.i_subdivision
      );
    }
  }, [applicant.adressfact.i_subdivision]);

  React.useEffect(() => {
    if (!isEmpty(applicant.adressfact.i_region)) {
      props.requestDataDirectories(
        'i_region_fact',
        applicant.adressfact.i_region
      );
    }
  }, [applicant.adressfact.i_region]);

  React.useEffect(() => {
    // const newCompleted = props.completed;
    setSubmitted(true);
    // const newCompleted = completed;

    if (
      !!applicant.adressfact.i_region &&
      !!applicant.adressfact.i_subdivision &&
      !!applicant.adressfact.i_locality &&
      !!applicant.adressfact.i_street &&
      !!applicant.adressfact.i_postindex &&
      !!applicant.adressfact.c_housing
    ) {
      // newCompleted[props.activeStep] = true;
      // // props.setCompleted(newCompleted);
      // // props.handleNext();
      // dispatch({ type: 'COMPLETED', payload: newCompleted });
      // console.log('true', newCompleted);
    } else {
      // const newCompleted = props.completed;
      // newCompleted[props.activeStep] = false;
      // // props.setCompleted(newCompleted);
      // dispatch({ type: 'COMPLETED', payload: newCompleted });
      // console.log('false', newCompleted);
    }
    // console.log(previousCompleted.current , props.completed[0]);
    // if (previousCompleted.current !== props.completed[0]) {
    //     props.setCompleted(newCompleted);
    //     previousCompleted.current = props.completed[0];
    // }
  }, [
    applicant.adressfact.i_region,
    applicant.adressfact.i_subdivision,
    applicant.adressfact.i_locality,
    applicant.adressfact.i_street,
    applicant.adressfact.i_postindex,
    applicant.adressfact.c_housing
  ]);

  return (
    <div className="marginForStatementBlock">
      <h3> Адреса фактичного місця проживання </h3>{' '}
      <Grid container spacing={2}>
        {/* <Grid direction="row" spacing={2}> */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="rergion"> Область </label>{' '}
            <div className="selectWrapper">
              <Select
                //value={applicant.applicant.adressfact.i_region}
                value={directories.region.filter(
                  ({ value }) =>
                    value === parseInt(applicant.adressfact.i_region)
                )}
                className={
                  submitted && !applicant.adressfact.i_region ? 'error' : ''
                }
                onChange={handleSelectChange('i_region_fact')}
                options={directories.region}
                name="i_region_fact"
                styles={styles.customStyles}
                placeholder=""
                //   isLoading={
                //     this.props.isFatching.DATA_FROM_DIRECTORIES
                //   }
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !applicant.adressfact.i_region && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="district"> Район </label>{' '}
            <div className="selectWrapper">
              <Select
                //value={applicant.adressfact.i_subdivision}
                value={directories.district_fact.filter(
                  ({ value }) =>
                    value === parseInt(applicant.adressfact.i_subdivision)
                )}
                className={
                  submitted && !applicant.adressfact.i_subdivision
                    ? 'error'
                    : ''
                }
                onChange={handleSelectChange('i_subdivision_fact')}
                options={directories.district_fact}
                name="i_subdivision_fact"
                //options={options}
                styles={styles.customStyles}
                //   isLoading={
                //     this.props.isFatching.SET_DISTRICT_FACT
                //   }
                placeholder=""
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !applicant.adressfact.i_subdivision && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="i_locality">Назва населеного пункту </label>{' '}
            <div className="selectWrapper">
              <Select
                //value={applicant.adressfact.i_locality}
                value={directories.city_fact.filter(
                  ({ value }) =>
                    value === parseInt(applicant.adressfact.i_locality)
                )}
                className={
                  submitted && !applicant.adressfact.i_locality ? 'error' : ''
                }
                onChange={handleSelectChange('i_locality_fact')}
                options={directories.city_fact}
                name="i_locality_fact"
                styles={styles.customStyles}
                //   isLoading={this.props.isFatching.SET_CITY_FACT}
                placeholder=""
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !applicant.adressfact.i_locality && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className="form-item">
            <label htmlFor="street"> Вулиця </label>{' '}
            <div className="selectWrapper">
              <Select
                //value={applicant.adressfact.i_street}
                value={directories.street_fact.filter(
                  ({ value }) =>
                    value === parseInt(applicant.adressfact.i_street)
                )}
                className={
                  submitted && !applicant.adressfact.i_street ? 'error' : ''
                }
                onChange={handleSelectChange('i_street_fact')}
                options={directories.street_fact}
                //   isLoading={this.props.isFatching.SET_CITY_FACT}
                name="i_street_fact"
                //options={options}
                styles={styles.customStyles}
                placeholder=""
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !applicant.adressfact.i_street && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={2} lg={2}>
          <div className="form-item">
            <label htmlFor="i_postindex">Відділення зв’ зку </label>{' '}
            <div className="selectWrapper">
              <Select
                //value={applicant.adressfact.i_postindex}
                value={directories.index_fact.filter(
                  ({ value }) =>
                    parseInt(value, 10) ===
                    parseInt(applicant.adressfact.i_postindex)
                )}
                onChange={handleSelectChange('i_postindex_fact')}
                className={
                  submitted && !applicant.adressfact.i_postindex ? 'error' : ''
                }
                options={directories.index_fact}
                getOptionLabel={({ value }) => value}
                name="i_postindex_fact"
                styles={styles.customStyles}
                placeholder=""
                //   isLoading={
                //     this.props.isFatching.SET_DISTRICT_FACT
                //   }
                noOptionsMessage={() => 'помилка серверу'}
                menuPortalTarget={document.body}
                theme={styles.customTheme}
              />{' '}
              {submitted && !applicant.adressfact.i_postindex && (
                <FormHelperText error id="name-error-text">
                  {' '}
                  Поле обов 'язкове
                </FormHelperText>
              )}{' '}
            </div>{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={2} lg={1}>
          <div className="form-item">
            <label htmlFor="c_housing">Будинок </label>{' '}
            <BuildingInput
              className={
                submitted && !applicant.adressfact.c_housing ? 'error' : ''
              }
              name="c_housing_fact"
              type="text"
              value={
                applicant.adressfact.c_housing === 0
                  ? ''
                  : applicant.adressfact.c_housing
              }
              onChange={handleInputChange}
            />{' '}
            {submitted && !applicant.adressfact.c_housing && (
              <FormHelperText error id="name-error-text">
                {' '}
                Поле обов 'язкове
              </FormHelperText>
            )}{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={2} lg={1}>
          <div className="form-item">
            <label htmlFor="c_building">Корпус </label>{' '}
            <CorpsInput
              //className={(submitted && !applicant.adressfact.c_building) && 'error'}
              name="c_building_fact"
              type="text"
              value={
                applicant.adressfact.c_building === 0
                  ? ''
                  : applicant.adressfact.c_building
              }
              onChange={handleInputChange}
            />{' '}
            {/* {(submitted && !applicant.adressfact.c_building) && <FormHelperText error id="name-error-text">Поле обов'язкове</FormHelperText>} */}{' '}
          </div>{' '}
        </Grid>{' '}
        <Grid item xs={12} sm={6} md={2} lg={1}>
          <div className="form-item">
            <label htmlFor="c_flat">Квартира </label>{' '}
            <FlatInput
              //className={(submitted && !applicant.adressfact.c_flat) && 'error'}
              name="c_flat_fact"
              type="text"
              value={
                applicant.adressfact.c_flat === 0
                  ? ''
                  : applicant.adressfact.c_flat
              }
              onChange={handleInputChange}
            />{' '}
            {/* {(submitted && !applicant.adressfact.c_flat) && <FormHelperText error id="name-error-text">Поле обов'язкове</FormHelperText>} */}{' '}
          </div>{' '}
        </Grid>{' '}
        {/* </Grid> */}
        <Grid direction="row" container spacing={2}>
          <Grid item xs={12}>
            {/* <Button
            disabled={props.activeStep === 0}
            onClick={props.handleBack}
            // className={classes.button}
          >
            Назад
          </Button> */}
            {/* <Button
              variant="contained"
              color="primary"
              onClick={props.handleNext}
              className="mr-2"
            >
              Наступна
            </Button> */}
            <Button
              variant="contained"
              color="secondary"
              // onClick={props.handleNext}
              onClick={handleSaveAddress}

              // className={classes.button}
            >
              {/* Next */}
              Зберегти
            </Button>
            {/* {props.activeStep !== props.steps.length &&
                (props.completed[props.activeStep] ? (
                  <Typography variant="caption">
                    Step {props.activeStep + 1} already completed
                  </Typography>
                ) : ( */}
            {/* <Button variant="contained" color="primary" onClick={handleComplete}> */}
            {/* {props.completedSteps() === props.totalSteps() - 1
                      ? 'Finish' */}
            {/* :  */}
            {/* Complete Step */}
            {/* '} */}
            {/* </Button> */}
            {/* ))} */}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  applicant: state.applicant,
  directories: state.directories,
  application: state.application
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, {
  requestDataDirectories,
  saveAddress,
  apllicantData
})(Address);
